(function () {
  if (window.waveblockSectionCollectionEqualizerLoaded) {
    return;
  }

  window.waveblockSectionCollectionEqualizerLoaded = true;

  const sectionSelector = '[data-section-type="section-collection"]';
  const cardSelector = '.product-grid-item';
  const resizeDelay = 150;
  const retryDelays = [100, 350, 800, 1500];
  const mobileMaxWidth = 767;

  const timers = new WeakMap();
  const observers = new WeakMap();

  function isMobileViewport() {
    return window.innerWidth <= mobileMaxWidth;
  }

  function getVisibleCards(section) {
    return Array.from(section.querySelectorAll(cardSelector)).filter((card) => {
      return card.offsetParent !== null && card.getClientRects().length > 0;
    });
  }

  function resetCardHeights(cards) {
    cards.forEach((card) => {
      card.style.height = '';
      card.style.minHeight = '';

      const gridItem = card.closest('.grid__item');
      if (gridItem) {
        gridItem.style.height = '';
        gridItem.style.minHeight = '';
      }
    });
  }

  function refreshFlickity(section) {
    if (isMobileViewport()) {
      return;
    }

    const slideshow = section.querySelector('[data-slideshow].flickity-enabled');
    const flickity = window.Flickity && slideshow ? window.Flickity.data(slideshow) : null;

    if (flickity) {
      flickity.resize();
      flickity.reposition();
    }
  }

  function equalizeCards(section) {
    const cards = getVisibleCards(section);

    resetCardHeights(cards);

    if (cards.length < 2) {
      refreshFlickity(section);
      return;
    }

    const tallestCard = Math.ceil(
      Math.max(
        ...cards.map((card) => {
          return card.offsetHeight;
        })
      )
    );

    cards.forEach((card) => {
      card.style.height = `${tallestCard}px`;
    });

    refreshFlickity(section);
  }

  function scheduleEqualize(section, delay) {
    window.clearTimeout(timers.get(section));

    const timer = window.setTimeout(() => {
      window.requestAnimationFrame(() => equalizeCards(section));
    }, delay);

    timers.set(section, timer);
  }

  function observeSection(section) {
    if (observers.has(section)) {
      return;
    }

    const observer = new MutationObserver(() => {
      scheduleEqualize(section, resizeDelay);
    });

    observer.observe(section, {
      childList: true,
      subtree: true,
      characterData: true,
    });

    observers.set(section, observer);
  }

  function initSection(section) {
    observeSection(section);
    scheduleEqualize(section, 0);

    retryDelays.forEach((delay) => {
      window.setTimeout(() => scheduleEqualize(section, 0), delay);
    });

    section.querySelectorAll('img').forEach((image) => {
      if (!image.complete) {
        image.addEventListener('load', () => scheduleEqualize(section, 0), { once: true });
        image.addEventListener('error', () => scheduleEqualize(section, 0), { once: true });
      }
    });
  }

  function initSections() {
    document.querySelectorAll(sectionSelector).forEach(initSection);
  }

  document.addEventListener('DOMContentLoaded', initSections);
  document.addEventListener('shopify:section:load', (event) => {
    const section = event.target.querySelector(sectionSelector) || event.target.closest(sectionSelector);

    if (section) {
      initSection(section);
    }
  });

  window.addEventListener('resize', () => {
    document.querySelectorAll(sectionSelector).forEach((section) => {
      scheduleEqualize(section, resizeDelay);
    });
  });

  document.addEventListener('theme:resize', () => {
    document.querySelectorAll(sectionSelector).forEach((section) => {
      scheduleEqualize(section, 0);
    });
  });
})();
